import { render } from "./KhrcNavbar.vue?vue&type=template&id=8de8df4e&scoped=true"
import script from "./KhrcNavbar.vue?vue&type=script&lang=js"
export * from "./KhrcNavbar.vue?vue&type=script&lang=js"

import "./KhrcNavbar.vue?vue&type=style&index=0&id=8de8df4e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8de8df4e"]])

export default __exports__